import { render, staticRenderFns } from "./TextImage.vue?vue&type=template&id=9f283f28&scoped=true"
import script from "./TextImage.vue?vue&type=script&lang=js"
export * from "./TextImage.vue?vue&type=script&lang=js"
import style0 from "./TextImage.vue?vue&type=style&index=0&id=9f283f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f283f28",
  null
  
)

export default component.exports